import retrieveFormsApi from '../api/forms/retrieveFormsApi';
import * as types from './actionTypes';
import * as errorMessages from '../constants/errorMessages';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions'; //eslint-disable-line no-unused-vars

export function formRetrievedSuccessful(form) {
  return {type: types.RETRIEVED_ALL_FORMS_SUCCESS, form};
}

export function retrieveAllForms() {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return retrieveFormsApi.retrieveAllForms()
      .then(response => {
        if (response.forms) {
          dispatch(formRetrievedSuccessful(response.forms));
          return response.forms;
        } else {
          dispatch(startAjaxCallError(errorMessages.ERROR_FORMS));
        }
      }).catch(error =>{
        dispatch(startAjaxCallError(error));
        throw error;
      });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/formActions.js
 **/